import React from "react";

const CustomSelect = (props) => {
  return (
    <select
      className="p-2 outline-none input-border br-4 fs-16"
      style={{ width: "inherit" }}
      value={props.value}
      onChange={props.onSelect}
    >
      {props.options?.map((data) => {
        return <option key={data._id || data} value={data._id || data}>{data.name || data}</option>
      })}
    </select>
  );
};

export default CustomSelect;
